import HttpError from "../../error/HttpError";

export const cleanUp = (script, staticFunction) => {
  if (script.parentNode) {
    script.parentNode.removeChild(script);
  }
  try {
    delete window[staticFunction];
  } catch (e) {
    window[staticFunction] = undefined;
  }
};

export const fetchJson = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new HttpError(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    throw new HttpError(error.message);
  }
};

export const fetchJsonWithPadding = async (url) => {
  return new Promise((resolve, reject) => {
    url = !url.includes("?") ? url + "?" : url + "&";
    const generatedFunction =
      "loc" + Math.round(new Date().getTime() + Math.random() * 9999999);
    const script = document.createElement("script");
    const src = url + "callback=" + generatedFunction;
    script.src = src;
    document.getElementsByTagName("head")[0].appendChild(script);
    script.onerror = (error) => {
      cleanUp(script, generatedFunction);
      reject(new HttpError(error.message));
    };
    window[generatedFunction] = (response) => {
      cleanUp(script, generatedFunction);
      resolve(response);
    };
  });
};

const http = {
  async get(url, useJsonP = false) {
    if (useJsonP) {
      return await fetchJsonWithPadding(url);
    }
    return await fetchJson(url);
  },
  removeUrlParam(url, paramName) {
    try {
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);
      params.delete(paramName);
      return `${urlObj.origin}${urlObj.pathname}${
        params.toString() ? "?" + params.toString() : ""
      }${urlObj.hash}`;
    } catch (e) {
      console.error("Error removing parameter from URL:", e);
      return url;
    }
  },
};

export default http;
